const fetch= require('node-fetch');
const hostname = window.location.hostname != 'localhost' ? window.location.hostname : 'v2.donuz.co'
const base_url = 'https://donuz.co/api/v1/';
console.log('base_url :>> ', base_url)
var config = require('../config.json')
const token = config.token;

export async function get(url, header = null) {
    if (header == null){
        header = {
            'token': token
        }
    }
    let obj = await fetch(base_url + url, {
            headers: header,
            cache: "no-cache"
        })
        .then((data) => (data.json())).catch((data) => console.log(data));
    return obj;
}
export async function post(url, header, parameter) {
    let obj = await fetch(base_url + url, {
            method: 'POST',
            headers: header,
            body: JSON.stringify(parameter),
            json: true
        }).then((data) => (data.json())).catch((data) => console.log(data));
    return obj;
}